import { useNavigate } from "react-router-dom";
import Logo from "../design/Logo";
import CardText from "../design/CardText";
import CardTextNumber from "../design/CardTextNumber";

const LiteracyLearning = () => {
  const textArray = ["기", "초", "학", "습"];
  const cardData = {
    title: "문해력 학습의 장점",
    items: [
      "자기주도 학습📖 정보를 분석하고 중요한 내용을 스스로 찾는 능력을 키웁니다.",
      "종합적 접근🤔 읽기, 쓰기, 비판적 사고를 함께 발달시킵니다.",
      "참여 유도📣 학생들이 읽기에 흥미를 갖고 문제 해결에 참여하도록 합니다.",
      "학업 성취도 향상📈 읽기 어려움을 해결하고 성취도를 높입니다.",
    ],
  };

  const cardData1 = {
    title: "독해 학습의 장점",
    items: [
      "문장을 구성하는 각 문법 요소(주어, 목적어, 동사, 부사 등)를 정확히 파악하고 분석할 수 있도록 합니다.",
      "각 문장 요소를 바탕으로 적절한 질문을 구성하여 문법적 이해와 사고력을 키웁니다.",
      "문장의 주요 명사를 재배열하여 문장의 구성 요소를 유연하게 이해하는 능력을 함양합니다.",
      "문장의 의미를 종합적으로 파악하고, 이모티콘을 사용하여 문장을 창의적으로 재구성하는 능력을 키웁니다.",
    ],
  };

  const activitySections = [
    {
      title: "1. 읽기 전 준비",
      items: [
        "배경지식 활성화: 글에 대한 관심을 끌어 배경지식을 떠올리게 합니다.",
        "어휘 준비: 어려운 어휘를 미리 설명해 독해를 돕습니다.",
      ],
    },
    {
      title: "2. 읽기 중 활동",
      items: [
        "주요 정보 파악: 학생들이 중요한 내용을 메모하게 합니다.",
        "질문 생성: 학생들이 질문을 통해 글을 깊이 이해하도록 유도합니다.",
        "베껴쓰기: 내용을 정리하고 글쓰기 능력을 키웁니다.",
      ],
    },
    {
      title: "3. 읽기 후 활동",
      items: [
        "요약하기: 글의 핵심을 간결하게 요약합니다.",
        "토론 및 발표: 생각을 공유하며 논리적 표현 능력을 키웁니다.",
      ],
    },
    {
      title: "4. 지속적 피드백 및 점검",
      items: ["진행 확인: 어려움을 파악하고 추가 도움을 줍니다."],
    },
    {
      title: "5. 독서 기록",
      items: ["읽은 내용을 기록하며 자기 성찰을 돕습니다."],
    },
  ];

  const activitySections1 = [
    {
      title: "1. 재미있는 동화로 학습",
      items: [
        "수준에 맞는 어휘와 재미있는 스토리로 영어학습을 재미있게 합니다.",
      ],
    },
    {
      title: "2. 각 문장을 문법요소로 분류",
      items: ["각 문장을 문법요소들로 구분하여 파악할 수 있도록 합니다."],
    },
    {
      title: "3. 각 단어의 문법요소를 맞춰보기",
      items: [
        "각 단어의 문법요소를 맞추는 문제를 풀면서 문장을 문법요소로 구분해서 보는 시각을 기릅니다.",
      ],
    },
    {
      title: "4. 이모티콘으로 단어를 표현하여 학습",
      items: [
        "각 단어를 이모티콘으로 만들고 이를 재배열 해보며 문장을 완성하는 힘을 기릅니다.",
      ],
    },
    {
      title: "5. 복습과 반복학습",
      items: [
        "이를 복습하고 반복학습 하므로써 실제 자신의 것으로 만들어갑니다.",
      ],
    },
  ];

  const navigate = useNavigate();

  const onLiteracyPlayClick = () => {
    navigate("/fun_learning/literacyplay");
  };

  const onReadingComprehensionPlayClick = () => {
    //기능 추가되면 다시 링크 제대로 걸기
    navigate("/fun_learning/reading");
  };

  return (
    <section className="bg-gray-200 dark:bg-gray-700">
      <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6">
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="mb-4 text-3xl sm:text-5xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            기초 학습
          </h2>
          <div className=" pt-10 font-bold text-gray-600 sm:text-xl dark:text-gray-400">
            준비가 되었다면?
          </div>
          <button
            onClick={onLiteracyPlayClick}
            className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-amber-600 to-amber-500 hover:bg-gradient-to-b dark:shadow-amber-900 shadow-amber-200 hover:shadow-2xl hover:shadow-amber-400 hover:-tranneutral-y-px "
          >
            문해력학습 하러가기!
          </button>
          <div></div>
          <button
            onClick={onReadingComprehensionPlayClick}
            className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-indigo-600 to-indigo-500 hover:bg-gradient-to-b dark:shadow-indigo-900 shadow-indigo-200 hover:shadow-2xl hover:shadow-indigo-400 hover:-tranneutral-y-px "
          >
            독해학습 하러가기!
          </button>
        </div>
        <Logo textArray={textArray} />
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            기초 학습이란?
          </h2>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            문해력학습, 으로
            <br />
            학습이 더딘 사람들도 문해력과 독해력을 기를 수 있는
            <br />
            보카톡톡만의 학습법입니다
          </p>
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-amber-600 dark:text-amber-300">
            문해력 학습이란?
          </h2>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            학생들이 독해 능력을 키우고
            <br /> 중요한 정보를 파악할 수 있도록 돕습니다.
          </p>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            독서를 통해 사고력, 언어 표현력,
            <br />
            자기 주도적 학습을 촉진합니다.
          </p>
        </div>
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            더 자세하게 알아보기
          </h2>
        </div>
        <CardText title={cardData.title} items={cardData.items} />

        <CardTextNumber title="문해력 학습 활동" sections={activitySections} />

        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-indigo-700 dark:text-indigo-300">
            독해 학습이란?
          </h2>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            문법 요소의 파악능력을 기르고 질문 능력의 향상을 통한
            <br />
            문법적 이해와 사고력을 키울 수 있게 합니다.
            <br />
            다양한 이모티콘을 이용하여 딱딱한 문법을 재미있게 접근합니다.
          </p>
        </div>
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            더 자세하게 알아보기
          </h2>
        </div>
        <CardText title={cardData1.title} items={cardData1.items} />
        <CardTextNumber title=" 활동" sections={activitySections1} />
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            이러한 효과가!
          </h2>
          <div className="text-5xl mb-3">🏆</div>
          <p className="mb-5 text-3xl text-blue-600 font-bold dark:text-blue-400">
            학생들은 깊이 있는 사고와 질문을 통해
            <br /> 다양한 텍스트를 이해합니다!
          </p>
        </div>
      </div>
    </section>
  );
};

export default LiteracyLearning;
